<template>
    <div class="global-monitoring">
        <div class="card-content message-card-content" v-if="cardHidden">
            <div>双十一临时管控，计划11月25号开启。</div>
        </div>
        <div class="card-content" v-else v-loading="loading">
            <card class="card-content-item" v-for="(item, index) in carList" :key="index"
                :title="item.title"
                :leftPercentage="item.leftPercentage"
                :rightPercentage="item.rightPercentage"
                :leftColor="item.leftColor"
                :rightColor="item.rightColor"
                :leftProgressDesc="item.leftProgressDesc"
                :rightProgressDesc="item.rightProgressDesc"
                :leftSatelliteInformation="item.leftSatelliteInformation"
                :rightSatelliteInformation="item.rightSatelliteInformation"
                :leftSatelliteInformationNum="item.leftSatelliteInformationNum"
                :rightSatelliteInformationNum="item.rightSatelliteInformationNum"
                >
            </card>
        </div>
    </div>
</template>

<script>
import card from '@/components/lots/card';
import { getOrderBoard, controlParams } from '../../../api/orderPanel';
import { mapGetters } from 'vuex';

export default {
    components: {
        card
    },
    data() {
        return {
            carList: [],
            loading: false,
            cardHidden: false
        };
    },
    methods: {
        getData() {
            this.loading = true;
            this.carList = [];
            getOrderBoard({
                code: this.supplier.supplierCode,
                params: [
                    'NEED_ARRIVE_WH',
                    'NEED_DEPART',
                    'NEED_ARRIVE',
                    'NEED_UPLOAD',
                    'NEED_SATISFIED'
                ]
            }).then(res => {
                if (res) {
                    const sort = [
                        {
                            code: 'NEED_ARRIVE_WH',
                            title: '到车',
                            leftColor: '#00c0c1',
                            rightColor: '#00c0c1',
                            leftProgressDesc: '当日及时率',
                            rightProgressDesc: '当月及时率',
                            leftSatelliteInformation: '应到车',
                            rightSatelliteInformation: '超时未到'
                        }, {
                            code: 'NEED_DEPART',
                            title: '发车',
                            leftColor: '#6CC100',
                            rightColor: '#6CC100',
                            leftProgressDesc: '当日及时率',
                            rightProgressDesc: '当月及时率',
                            leftSatelliteInformation: '应发车',
                            rightSatelliteInformation: '超时未发'
                        }, {
                            code: 'NEED_ARRIVE',
                            title: '配送',
                            leftColor: '#008BED',
                            rightColor: '#008BED',
                            leftProgressDesc: '当日及时率',
                            rightProgressDesc: '当月及时率',
                            leftSatelliteInformation: '应配送',
                            rightSatelliteInformation: '超时未配'
                        }, {
                            code: 'NEED_UPLOAD',
                            title: '回单上传',
                            leftColor: '#CD7FFF',
                            rightColor: '#CD7FFF',
                            leftProgressDesc: '当日及时率',
                            rightProgressDesc: '当月及时率',
                            leftSatelliteInformation: '应上传',
                            rightSatelliteInformation: '超时未传'
                        }, {
                            code: 'RETURN',
                            title: '退货',
                            leftColor: '#FFBA00',
                            rightColor: '#FFBA00',
                            leftProgressDesc: '当日及时率',
                            rightProgressDesc: '当月及时率',
                            leftSatelliteInformation: '应退回',
                            rightSatelliteInformation: '超时未退'
                        }, {
                            code: 'NEED_SATISFIED',
                            title: '满意度',
                            leftColor: '#7A77FF',
                            rightColor: '#7A77FF',
                            leftProgressDesc: '当日及时率',
                            rightProgressDesc: '当月及时率',
                            leftSatelliteInformation: '总单量',
                            rightSatelliteInformation: '不满意'
                        }
                    ];
                    sort.forEach(item => {
                        const data = res.data[item.code];
                        this.carList.push({
                            title: item.title,
                            leftColor: item.leftColor,
                            rightColor: item.rightColor,
                            leftProgressDesc: item.leftProgressDesc,
                            rightProgressDesc: item.rightProgressDesc,
                            leftSatelliteInformation: item.leftSatelliteInformation,
                            rightSatelliteInformation: item.rightSatelliteInformation,
                            leftPercentage: +data.dayIndicator,
                            rightPercentage: +data.monthIndicator,
                            leftSatelliteInformationNum: +data.resultOne,
                            rightSatelliteInformationNum: +data.resultTwo
                        });
                    });
                }
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    mounted () {
        controlParams({ codeParam: 'LSRM_IS_SHOW_TMSPAGE' }).then(res => {
            if (res && res.code === '0' && res.data.list.length && ['Y', 'YES'].includes(res.data.list[0].value)) {
                this.getData();
            } else {
                this.cardHidden = true;
            }
        });
    },
    computed: {
        ...mapGetters(['supplier'])
    }
};
</script>

<style lang="less">
.global-monitoring {
    .card-content {
        display: flex;
        flex-wrap: wrap;
        padding: 30px 0 30px 12px;
        min-height: 300px;
    }
    .message-card-content {
        background: white;
        justify-content: center;
        align-items: center;
        font-size: 20px;
    }
    .card-content-item {
        width: 30%;
        margin: 0 3.3% 3.3% 0;
    }
}
</style>